import React from 'react';
import { addDays, format } from 'date-fns';

/**
 * Component to display when no appointments are found for the selected date
 */
const NoAppointmentsForDateView = ({ date, formatDateFull, onSelectNextAvailableDate, nextAvailableDate }) => {
  // Use the provided next available date if available, otherwise suggest a date 3 days from now
  const suggestFutureDate = () => {
    if (nextAvailableDate) {
      return nextAvailableDate;
    }
    
    const futureDate = new Date();
    futureDate.setDate(futureDate.getDate() + 3);
    return format(futureDate, 'yyyy-MM-dd');
  };
  
  const suggestedDate = suggestFutureDate();
  
  return (
    <div className="bg-yellow-50 p-6 rounded-lg border border-yellow-200 mb-6">
      <h3 className="text-lg font-semibold text-yellow-800 mb-2">
        No Available Appointments
      </h3>
      
      <p className="text-gray-700 mb-4">
        There are no available appointments for {formatDateFull(date)}. Please select a different date or try another practice.
      </p>
      
      <div className="mb-4">
        <button
          onClick={() => onSelectNextAvailableDate && onSelectNextAvailableDate(suggestedDate)}
          className="bg-blue-500 hover:bg-blue-600 text-white font-medium py-2 px-4 rounded transition-colors"
        >
          Try {formatDateFull(suggestedDate)}
        </button>
      </div>
      
      <div className="text-sm text-gray-600">
        <p className="mb-2">
          <strong>Tip:</strong> Try selecting a date further in the future or contact our customer service team directly.
        </p>
        <p>
          <strong>Phone:</strong> <a href="tel: +447457411865">
          07457 411 865
          </a>
        </p>
      </div>
    </div>
  );
};

export default NoAppointmentsForDateView;
